import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
var LoginBoxDialogComponent = /** @class */ (function () {
    function LoginBoxDialogComponent(dialogRef, data, fb) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this.CancelTried = false;
        this.title = data.TitleText || 'Credentials Required';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.validators = data.Validators || null;
        this.username = data.Username || null;
    }
    LoginBoxDialogComponent.prototype.ngOnInit = function () {
        // Set up the form group
        this.loginForm = this.fb.group({
            username: [this.username],
            password: [null],
        });
        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            var ctrl = this.loginForm.get('username');
            var toSet = [Validators.required].concat(this.validators);
            ctrl.setValidators(this.validators);
            this.loginForm.updateValueAndValidity();
        }
    };
    LoginBoxDialogComponent.prototype.CancelHandler = function () {
        if (this.CancelTried !== true) {
            // Set the flag, so the user has to hit it a second time.
            this.CancelTried = true;
            return;
        }
        // Oh well. Close it.
        this.dialogRef.close(null);
    };
    LoginBoxDialogComponent.prototype.OKHandler = function () {
        var response = this.loginForm.value;
        this.dialogRef.close({
            Username: response.username,
            Password: response.password,
        });
    };
    return LoginBoxDialogComponent;
}());
export { LoginBoxDialogComponent };
// #region Custom Classes
// #region Base Login Box Dialog Options Class
var BaseLoginBoxDialogOptions = /** @class */ (function () {
    function BaseLoginBoxDialogOptions() {
    }
    return BaseLoginBoxDialogOptions;
}());
export { BaseLoginBoxDialogOptions };
// #endregion
// #region Base Login Box Dialog Result Class
var BaseLoginBoxDialogResult = /** @class */ (function () {
    function BaseLoginBoxDialogResult() {
    }
    return BaseLoginBoxDialogResult;
}());
export { BaseLoginBoxDialogResult };
// #endregion
// #endregion
